module.exports = () => {
  return [
    {
      name: '抖音号ID',
      value: 'id',
    },
    {
      name: '抖音昵称',
      value: 'name',
    },
    {
      name: '可投放视频数',
      value: 'can_delivery_item_count',
      format: (row) => {
        const { can_delivery_item_count } = row;
        return (can_delivery_item_count || can_delivery_item_count === 0) ? can_delivery_item_count : '-';
      },
    },
  ];
};
